import styles from "./Menu.desktop.module.css";
import { getDesktopMenuWidth } from "../../../tools/ConfigurationReader.ts";
import React, { type CSSProperties } from "react";
import { FaCircle, FaRegUser, FaRightFromBracket } from "react-icons/fa6";
import isAdmin from "../../../security/IsAdmin.ts";
import { formatVersion } from "../../../tools/formatters/VersionFormatter.ts";
import { useMenuController } from "../Menu.controller.ts";
import { useTranslation } from "react-i18next";
import type MenuGeneralProperties from "../Menu.General.properties.ts";

export default function MenuGeneralView(props: MenuGeneralProperties) {
  const { t } = useTranslation();
  const { firstname, lastname, handleLogoutClick, backendVersion } =
    useMenuController();

  return (
    <div
      className={styles.menuContainer}
      style={
        {
          "--menuWidth": getDesktopMenuWidth(),
        } as CSSProperties
      }
    >
      <div className={styles.menuContent}>
        {/* Logo */}
        <img
          className={styles.logo}
          src="/images/logo.png"
          alt={t("ui.altLogo")}
        />

        {/* User Information */}
        <div className={styles.menuItemContainer}>
          <div className={styles.menuItemIconContainer}>
            <FaRegUser className={styles.icon} />
          </div>
          <div className={styles.userNameContainer}>
            <p className={styles.userName}>
              {firstname}
              <br />
              {lastname}
            </p>
          </div>
        </div>

        <hr className={styles.horizontalSeparator} />

        {props.children}

        {/* Logout */}
        <>
          <div className={styles.menuItemContainer} onClick={handleLogoutClick}>
            <div className={styles.menuItemIconContainer}>
              <FaRightFromBracket className={styles.icon} />
            </div>
            <div className={styles.menuItemLabelContainer}>
              <p className={styles.menuItemLabel}>{t("ui.logout")}</p>
            </div>
          </div>

          <hr className={styles.horizontalSeparator} />
        </>

        {/* Legend */}
        {!isAdmin() && (
          <>
            <div className={styles.redCircleLineContainer}>
              <div className={styles.redCircleIconContainer}>
                <FaCircle className={styles.redCircle} />
              </div>
              <div className={styles.redCircleContainer}>
                <p className={styles.redCircleLabel}>{t("ui.toReview")}</p>
              </div>
            </div>
            <div className={styles.yellowCircleLineContainer}>
              <div className={styles.yellowCircleIconContainer}>
                <FaCircle className={styles.yellowCircle} />
              </div>
              <div className={styles.yellowCircleContainer}>
                <p className={styles.yellowCircleLabel}>
                  {t("ui.toBeReviewedSoon")}
                </p>
              </div>
            </div>
            <div className={styles.greenCircleLineContainer}>
              <div className={styles.greenCircleIconContainer}>
                <FaCircle className={styles.greenCircle} />
              </div>
              <div className={styles.greenCircleContainer}>
                <p className={styles.greenCircleLabel}>{t("ui.okay")}</p>
              </div>
            </div>

            <hr className={styles.horizontalSeparator} />
          </>
        )}

        {/* Version */}
        {isAdmin() && (
          <>
            <div className={styles.menuItemContainer}>
              <div className={styles.menuVersionContainer}>
                <p>{formatVersion(backendVersion?.version, t)}</p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
